export const SearchTypes = {
  startNumber: "startNumber",
  selfie: "selfie",
  email: "email",
}